export default function Canvas_Rectangles() {
  return (
    <div>
      <h1>Canvas_Rectangles Component</h1>
    </div>
  );
}
